import { Component,Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

export type EwDeleteDialogBoxResultType = 'positive' | 'negative' | 'close';
type Color = 'warn' | 'primary' | 'default' | 'accent';


export interface EwDeleteDialogBoxData {
  title?: string;
  description: string;
  positiveBtnText: string;
  negativeBtnText: string;
  positiveBtnColor?: Color;
  negativeBtnColor?: Color;
  dialogBoxIcon?: string;
}
@Component({
  selector: 'lib-ew-delete-dialogbox',
  templateUrl: './ew-delete-dialogbox.component.html',
  styleUrls: ['./ew-delete-dialogbox.component.css']
})
export class EwDeleteDialogboxComponent implements OnInit {

  constructor(
    private readonly dialogRef: MatDialogRef<
    EwDeleteDialogboxComponent,
    EwDeleteDialogBoxResultType
  >,
  @Inject(MAT_DIALOG_DATA) public data:  EwDeleteDialogBoxData
  ) { }

  ngOnInit(): void {
  }
  close() {
    this.dialogRef.close('close');
  }
  submitResult(result: EwDeleteDialogBoxResultType) {
    this.dialogRef.close(result);
  }
}
